import { noop } from 'lodash';

import SharedStrategy from './SharedStrategy';
import { collectRefundPaymentMethod, processRefund, captureRefund, refundFail } from './actions';
import {
  readyToRefund,
  setExternalPaymentInfo,
} from '../register/webReader/actions';
import { setProcessing } from '../register/tipping/actions';
import { getActiveShopCurrency, isApiReaderEnabledForShop } from '../auth/selectors';
import { getIsProcessorMode } from '../register/webReader/selector';
import * as paymentActions from '../register/payment/actions';
import { paymentFailed } from '../main/payment/actions';

class RefundStrategy extends SharedStrategy {
  constructor() {
    super('refund');
  }

  discoverFail(error, dispatch) {
    dispatch(refundFail(error, this.getName()));
  }

  readerConnectSuccess(dispatch) {
    super.readerConnectSuccess(dispatch);
    dispatch(readyToRefund());
  }

  readerConnectError(error, dispatch) {
    super.readerConnectError(error, dispatch);
    dispatch(refundFail(error, this.getName()));
  }

  readerSelectCancel = noop;

  resetWebreaderPayment(dispatch) {
    dispatch(refundFail({}, this.getName()));
    this.dispose();
  }

  collectPaymentMethod(state, action, dispatch) {
    dispatch(setProcessing(true));

    const currency = getActiveShopCurrency(state);
    const payload = [action.payload.chargeId, action.payload.amount, currency.toLowerCase()];
    collectRefundPaymentMethod(dispatch)(payload, this.getName(), isApiReaderEnabledForShop(state));
  }

  process(state, action, dispatch) {
    processRefund(dispatch)(this.getName(), isApiReaderEnabledForShop(state));
  }

  capture(state, action, dispatch) {
    if (getIsProcessorMode(state)) {
      dispatch(setExternalPaymentInfo(null));
      return;
    }

    dispatch(captureRefund(this.getName()));
  }

  readerTransactionSuccess(state, action, dispatch) {
    dispatch(setProcessing(false));
    this.dispose();
  }

  readerTransactionFail(state, action, dispatch) {
    // don't involve register related handlers in case it's a web view processor
    if (!getIsProcessorMode(state)) {
      dispatch(paymentActions.readerTransactionFail(action.payload));
      dispatch(paymentFailed());
    }

    dispatch(setExternalPaymentInfo(null));

    dispatch(setProcessing(false));
    this.dispose();
  }

  handleCancelTransaction(state, action, dispatch) {
    // don't involve register related handlers in case it's a web view processor
    if (!getIsProcessorMode(state)) {
      dispatch(paymentActions.readerTransactionFail());
      dispatch(paymentFailed());
    }

    dispatch(setProcessing(false));
    this.dispose();
  }
}

export default new RefundStrategy();
